import { apiEndpoint } from 'configs'
import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getTnc = createAsyncThunk(
  'tnc',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const data = await axios.get(`${apiEndpoint}/api/v1/public/tnc`, config)

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const confirmTnc = createAsyncThunk(
  'confirm/tnc',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/bussines/user-consent`,
        {
          inboxnewsId: payload?.id,
          consentedType: 'TNC',
          consentedTypeVersion: payload?.version,
        },
        config,
      )

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
